export default __webpack_public_path__ + "static/media/aws-sns.b30d9bd1.svg";